export const sections = {
  Orders: 1800,
  Login: 2200
}

export const pages = {
  Delivery: 2500,
  Login: 3100
}

export const events = {
  DeliveryOrders: 2203,
  ViewDeliveryOrder: 2204,
  UserLogin: 2700
}
